import { Component } from "react";
import PayPalSecuredPaymentImg from "../Assets/paypal-secured-payment.png";
import {
  documentAllowed,
  ApiEndpoint,
  name,
  platform,
  hideRegion,
  summaryInputLimit,
} from "../Constant";
import Footer from "../Components/footer";
import Header from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import Form from "../Components/form";
import { Input, Textarea, Select, File } from "../Components/input";
import {
  RedirectNotLogin,
  RedirectContractor,
  getSession,
  UpdateState,
  getState,
  AlertMessage,
  AlertMessageOut,
  clearSession,
  popModal,
} from "../Components/function";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import * as axios from "axios";

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = "visitor") => {
  // Get the visitor identifier when you need it.
  const fp = await fpPromise;
  const result = await fp.get();

  // This is the visitor identifier:
  if (type === "visitor") {
    return result.visitorId;
  } else {
    //return result.visitorId;
  }
};

class Submit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userID: "",
      data: "",
      title: "",
      summary: "",
      target: "-1",
      file: "",
      author: "",
      affiliate: "",
      message: "",
      division_status: "0",
      submit_file_cost: "0",
      disable_regional_review: "",
      loading: "",
      isLoaded: 0,
    };
  }

  componentDidMount() {
    RedirectNotLogin();
    RedirectContractor();
    this.loadDataFromServer();
  }

  componentDidUpdate() {
    RedirectNotLogin();
    RedirectContractor();
  }

  loadDataFromServer = async () => {
    UpdateState(this, "loading", "1");

    let DeviceSid = await FingerPrint();

    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = new URLSearchParams({
      command: "fetch",
      cmd: "fetchsubmit",
      user_id: getSession("userID"),
    }).toString();

    axios
      .get(ApiEndpoint + "/fetchResult?" + datas, header)
      .then((response) => {
        UpdateState(this, "loading", "0");
        UpdateState(this, "isLoaded", 1);

        if (response?.data?.retry == true) {
          let retryTimes =
            getState(this, "retry_times") >= 0 &&
            getState(this, "retry_times") != ""
              ? getState(this, "retry_times")
              : "";
          if (retryTimes != "") {
            if (getState(this, "retry_times") < 15) {
              setTimeout(function () {
                UpdateState(
                  this,
                  "retry_times",
                  getState(this, "retry_times") + 1
                );
                this.loadDataFromServer();
              }, 4000);
            }
          }
        }

        if (response?.data?.error == false && response?.data?.error != true) {
          //alert(JSON.stringify(response?.data?.data));
          UpdateState(
            this,
            "data",
            response?.data?.data != "" ? response?.data?.data : ""
          );
          UpdateState(
            this,
            "division_status",
            response?.data?.division_status != ""
              ? response?.data?.division_status
              : "0"
          );
          UpdateState(
            this,
            "submit_file_cost",
            response?.data?.submit_file_cost != ""
              ? response?.data?.submit_file_cost
              : "0"
          );
          UpdateState(
            this,
            "show_pay_button",
            response?.data?.show_pay_button != ""
              ? response?.data?.show_pay_button
              : "0"
          );
          UpdateState(
            this,
            "disable_regional_review",
            response?.data?.disable_regional_review != ""
              ? response?.data?.disable_regional_review
              : ""
          );
          UpdateState(this, "message", "");
          UpdateState(this, "loading", "0");

          //alert(response?.data?.data);
        } else if (response?.data?.error != false) {
          AlertMessage(this, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            this,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          this,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        this.loadDataFromServer();
      });
  };

  render() {
    return (
      <div className="App AppWrap">
        <Header self={this} />
        <SideBar self={this} />

        <div className="App iBG dash-dash">
          <div className="containers">
            <div className="card-lt-wrap">
              <div className="card-lt">
                <div className="info" style={{ margin: "0px" }}>
                  Please{" "}
                  <a
                    href="#download-file"
                    className="download-file"
                    style={{ color: "brown" }}
                    data-file-url={getState(this, "data")}
                  >
                    <b>
                      <i className="fa fa-download"></i> Download File Format
                      here
                    </b>{" "}
                  </a>{" "}
                  to get started!
                </div>
                <div className="card-form-lt">
                  <div className="title-lt">Submit a File</div>

                  <Form route="submit">
                    <div
                      className="warning"
                      style={{ margin: "0px" }}
                      hidden={
                        getState(this, "submit_file_cost") < 1 ||
                        getState(this, "show_pay_button") < 1 ||
                        getState(this, "division_status") < 1
                      }
                    >
                      Article processing charge (APC) is{" "}
                      <b>${getState(this, "submit_file_cost")}</b>.
                    </div>

                    {AlertMessageOut(this)}

                    <Input
                      wrapperClass="form-group-lt"
                      inputType="text"
                      inputClass="input-lt"
                      inputState="title"
                      inputPlaceholder="Title"
                      inputMaxLength="1500"
                      self={this}
                    />

                    <Input
                      wrapperClass="form-group-lt"
                      inputType="text"
                      inputClass="input-lt"
                      inputState="author"
                      inputPlaceholder="Author(s) (separated by semi-colon)"
                      inputMaxLength="1500"
                      self={this}
                    />

                    <Textarea
                      wrapperClass="form-group-lt"
                      inputClass="input-lt"
                      inputState="affiliate"
                      inputPlaceholder="Affiliate(s) if any (separated by semi-colon)"
                      inputRows="2"
                      inputCols="50"
                      inputMaxLength="3000"
                      self={this}
                    />

                    <Textarea
                      wrapperClass="form-group-lt"
                      inputClass="input-lt"
                      inputState="summary"
                      inputPlaceholder="Summary - enter Abstract here"
                      inputRows="8"
                      inputCols="50"
                      inputMaxLength={summaryInputLimit}
                      self={this}
                    />

                    <small>
                      Upload manuscript without your names. No PDF format
                    </small>

                    <File
                      wrapperClass="form-group-lt"
                      inputClass="input-lt"
                      inputState="file"
                      inputPlaceholder="Upload File"
                      inputAccept={documentAllowed}
                      self={this}
                    />

                    <Select
                      wrapperClass="form-group-lt"
                      inputClass="input-lt"
                      inputState="target"
                      inputPlaceholder="-- Select Geo Target --"
                      inputSelected="-1"
                      inputOptions={[
                        { value: "-1", text: "Global Review" },
                        { value: "1", text: "Regional Review" },
                      ]}
                      inputDisabledAtValue={getState(
                        this,
                        "disable_regional_review"
                      )}
                      inputRequired="required"
                      inputHidden={hideRegion}
                      self={this}
                    />
                    <div
                      className="form-group-lt"
                      style={{ marginTop: "5px", marginBottom: "50px" }}
                    >
                      <a
                        href="#!"
                        onClick={(e) => {
                          e.preventDefault();
                          popModal("small", {
                            title: "Understanding Geo Targeting",
                            body: `
          <div style="line-height: 1.6; font-size: 14px;">
            <p>
              <strong>Regional review</strong> means that your manuscript would
              be reviewed by experts/scholars from your continent/region only.
              Choose this option if your research question or findings have much
              national or regional significance than global.
            </p>
            <p>
              <strong>Global review</strong> means that your manuscript would be
              reviewed by experts/scholars from any part of the world. Choose
              this option if your research question is of huge interest to the
              developed countries, and/or if your research findings have much
              more global significance than regional or national.
            </p>
            <p>
              <em>
                Honesty in choosing ensures that your manuscript isn't rejected
                unnecessarily.
              </em>
            </p>
            <p>
              <a href="https://unifiedscholars.org/geo-targeting-and-the-stratification-of-peer-review.html"
                 target="_blank"
                 rel="noopener noreferrer"
                 style="color: #0066cc;">
                Read more here
              </a>
            </p>
          </div>
        `,
                          });
                        }}
                        className="link-lt"
                      >
                        Learn more about review
                      </a>
                    </div>

                    {getState(this, "division_status") > 0 ? (
                      <Button
                        wrapperClass="form-group-lt"
                        buttonClass="button-lt"
                        buttonText="SUBMIT"
                        buttonAction="submit_file"
                        self={this}
                      />
                    ) : (
                      <>
                        <div
                          className="warning"
                          hidden={getState(this, "isLoaded") < 1}
                        >
                          Submission to your field of specialization would start
                          in few weeks, please check again later!
                        </div>
                        <Button
                          wrapperClass="form-group-lt"
                          buttonClass="button-lt"
                          buttonText="SUBMIT [Unavailable]"
                          buttonAction="none"
                          disabled="disabled"
                          self={this}
                        />
                      </>
                    )}

                    <div
                      className="warning-no"
                      style={{ margin: "0px" }}
                      hidden={
                        getState(this, "submit_file_cost") < 1 ||
                        getState(this, "show_pay_button") < 1 ||
                        getState(this, "division_status") < 1
                      }
                    >
                      <img
                        src={PayPalSecuredPaymentImg}
                        alt="PayPal Secured Payment"
                        style={{ maxWidth: "100%", maxHeight: "100px" }}
                      />
                    </div>
                  </Form>
                </div>
              </div>

              <Footer classX="dash-footer" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Submit;
